import { CommonModule, NgOptimizedImage } from '@angular/common';
import { ChangeDetectionStrategy, Component, inject, input } from '@angular/core';
import { RouterModule } from '@angular/router';
import {
  AnimateModule,
  GtmClickDirective,
  TrainingBrand,
  TrainingType,
  UserType,
  WwwAppState,
  WwwRouteSlug,
} from '@pro-connect/shared';
import { select } from '@ngxs/store';
import { ITrainingsList } from 'shared/src/pages/core/models/trainings-list';
import { NgxMaskPipe } from 'ngx-mask';
import { NgxSkeletonLoaderModule } from 'ngx-skeleton-loader';
import { Angulartics2GoogleTagManager } from 'angulartics2';

@Component({
  selector: 'app-training-tile',
  templateUrl: './training-tile.component.html',
  styleUrls: ['./training-tile.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [
    CommonModule,
    AnimateModule,
    RouterModule,
    NgxMaskPipe,
    NgOptimizedImage,
    NgxSkeletonLoaderModule,
    GtmClickDirective,
  ],
})
export class TrainingTileComponent {
  public readonly user = select(WwwAppState.user);
  public readonly WwwRouteSlug = WwwRouteSlug;
  public readonly training = input.required<ITrainingsList>();
  public readonly showPrice = input.required<boolean>();
  public readonly trainingBrand = input<TrainingBrand | null>(null);
  public readonly TrainingType = TrainingType;
  public readonly UserType = UserType;
  private readonly _angulartics2GoogleTagManager = inject(Angulartics2GoogleTagManager);

  private _pushEcommerceImpressionLayer(): void {
    this._angulartics2GoogleTagManager.pushLayer({
      event: 'nievent',
      eventCategory: 'Ecommerce',
      eventAction: 'Product impressions',
      eventLabel: 'trainings list page',
      event_name: 'view_item_list',
      ecommerce: {
        currencyCode: 'PLN',
        impressions: {
          name: this.training().name,
          subname: '',
          id: this.training().slug,
          price: this.training().price,
          brand: this.trainingBrand() ? this.trainingBrand() : '',
          category: this.training().training_type,
          variant: '',
          list: 'trainings',
          position: '',
          // TO DO  backend add variant to list elements
          // Input with position on list (question is it position in each page or position relative)
        },
      },
    });
  }
}
